<template>
	<SignUpPageBase :content="this" max-width="50%">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.beneficialOwners.title") }}</h4>
		<span v-html="$t('signUp.beneficialOwners.description')"></span>
		<div class="ownersGrid flex flex_center margin_top w_100">
			<template v-for="(owner, index) in form.beneficialOwners">
				<div class="break margin_top" v-if="index % 2 === 0"/>
				<SignUpBeneficialOwnerComponent
					class="ownerBox flex_1" :class="{'margin_l' : index % 2 === 1}"
					:data="owner"
					@edit="showEditOwnerModal(index)"
					@delete="deleteOwner(index)"
				></SignUpBeneficialOwnerComponent>
			</template>
		</div>
		<div class="margin_top w_100">
			<md-button class="md-blank" @click="showAddOwnerModal">
				{{ $t("signUp.beneficialOwners.button.add") }}
			</md-button>
		</div>
	</SignUpPageBase>
</template>

<script>

import SignUpPageBase from "@/views/register/SignUpPageBase";
import SignUpBeneficialOwnerComponent from "@/views/register/SignUpBeneficialOwnerComponent";
import {mapGetters} from "vuex";

export default {
	components: { SignUpBeneficialOwnerComponent, SignUpPageBase },
	data() {
		return {
			form: {
				beneficialOwners: []
			}
		};
	},
	created() {
		this.form.beneficialOwners = this.signUpData.beneficialOwners;
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData"
		}),
	},
	methods: {
		showEditOwnerModal(index) {
			this.$store.dispatch("setActionNoticModal", {
				show: true,
				data: {
					title: this.$t("beneficialOwners.modal.title"),
					type: "BeneficialOwnerModal",
					editType: "edit",
					width: "500",
					suFun: (data) => this.editOwner(data, index),
					data: this.form.beneficialOwners[index]
				}
			});
		},
		showAddOwnerModal() {
			this.$store.dispatch("setActionNoticModal", {
				show: true,
				data: {
					title: this.$t("beneficialOwners.modal.title"),
					type: "BeneficialOwnerModal",
					editType: "add",
					width: "500",
					suFun: this.addOwner
				}
			});
		},
		deleteOwner(index) {
			this.form.beneficialOwners.splice(index, 1);
		},
		editOwner(data, index) {
			this.form.beneficialOwners.splice(index, 1, data);
		},
		addOwner(data) {
			this.form.beneficialOwners.push(data);
		},
		confirmNext() {
			return new Promise((resolve, reject) => {
				if (this.form.beneficialOwners.length > 0) {
					resolve();
				} else {
					let option = {
						msg: this.$t("signUp.beneficialOwners.confirm.text"),
						confirmFun: resolve,
						cancelFun: reject
					};
					this.confirmMeg(option, true);
				}
			});
		}
	},
};
</script>

<style lang="scss" scoped>
	.ownersGrid {
		flex-wrap: wrap;
	}

	.ownerBox {
		max-width: 50%;
	}

	.break {
		flex-basis: 100%;
		height: 0;
	}

</style>